import api from './api';

// Universal API access, as a CHAIN or a HOTEL manages it.
//
// The MAIN api, not /admin. These are the same rows the superadmin screen manages, reached by the
// property that owns them — every route proves per request that the caller may reach the hotel, because
// the ordinary Cognito authorizer only proves they are signed in.
//
// Issuing the INBOUND credential is not here: `partnerMktSettingsService` already does it
// (generate-credentials + saveCredentials) and is already open to chain and hotel users. A second way to
// mint a credential would be a second place for it to be minted differently.
const uapiAccessService = {
    // A hotel's bindings, or every hotel in a chain with its bindings (hotels with none included, so
    // the chain screen can show what is NOT provisioned).
    list: ({ hotelId, accountId }) => {
        const qs = new URLSearchParams();
        if (hotelId) qs.set('hotelId', String(hotelId));
        if (accountId) qs.set('accountId', String(accountId));
        return api.get(`/uapi-access?${qs}`);
    },

    // The backend systems switched on for the Universal API.
    systems: () => api.get('/uapi-access/systems'),

    // Bind a property to a backend system. The x-hotelid is minted by the server — a client-supplied
    // one could collide with another property's or be chosen to reach one.
    //
    // `uapiCredentialId` is optional and names WHO PRESENTS the identifier. Left out, it is the
    // property's own Universal API credential (the chain and hotel screens). Given, it is a vendor's
    // credential — the partner routing one of its properties to a company it has onboarded. The server
    // proves the credential is a vendor's, that the caller administers its partner, and that the vendor
    // was granted the property, so passing it is a request rather than a permission.
    create: (payload) => api.post('/uapi-access', payload),

    get: (id) => api.get(`/uapi-access/${id}`),

    // Retires the x-hotelid with it: anything still sending that identifier stops being routed.
    remove: (id) => api.delete(`/uapi-access/${id}`),
};

export default uapiAccessService;
